import { queryOptions } from "@tanstack/react-query";
import { api, unwrap } from "@/client/lib/api";

const listNotes = async () => (await unwrap(api.notes.$get())).items;

export type NoteItem = Awaited<ReturnType<typeof listNotes>>[number];

/** The person's own notes, whole: the list, search and the editor all read this one copy. */
export const notesQuery = queryOptions({
  queryKey: ["notes"],
  queryFn: listNotes,
});

/** Pinned first, then the latest edited, as the server sorts them. */
export function sortNotes(notes: NoteItem[]): NoteItem[] {
  return [...notes].sort(
    (a, b) =>
      Number(b.pinnedAt !== null) - Number(a.pinnedAt !== null) ||
      (b.pinnedAt ?? "").localeCompare(a.pinnedAt ?? "") ||
      b.updatedAt.localeCompare(a.updatedAt),
  );
}

/** The scope a note's saves share, so they go one at a time and in order. */
export const noteScope = (id: string) => `note:${id}`;
